export default __webpack_public_path__ + "static/media/sync.e6ba0964.png";